import{main$}from"./main";import{NAVIGATE,ROUTE_WILL_ENTER,ROUTE_DID_ENTER,ROUTE_WILL_LEAVE,ROUTE_DID_LEAVE,ROUTE_DID_UPDATE}from"../constants/ActionTypes";/**
 * @type {Observable}
 */export var navigate$=main$.filter(function(_ref){var action=_ref.action;return action.type===NAVIGATE;});/**
 * @type {Observable}
 */export var routeWillEnter$=main$.filter(function(_ref2){var action=_ref2.action;return action.type===ROUTE_WILL_ENTER;});/**
 * @type {Observable}
 */export var routeDidEnter$=main$.filter(function(_ref3){var action=_ref3.action;return action.type===ROUTE_DID_ENTER;});/**
 * @type {Observable}
 */export var routeWillLeave$=main$.filter(function(_ref4){var action=_ref4.action;return action.type===ROUTE_WILL_LEAVE;});/**
 * @type {Observable}
 */export var routeDidLeave$=main$.filter(function(_ref5){var action=_ref5.action;return action.type===ROUTE_DID_LEAVE;});/**
 * @type {Observable}
 */export var routeDidUpdate$=main$.filter(function(_ref6){var action=_ref6.action;return action.type===ROUTE_DID_UPDATE;});/**
 * @type {Observable}
 * @deprecated use routeDidEnter$
 */export var routeDidChange$=routeDidEnter$;